import { useDrawerStore } from '@/global/store/useDrawerStore'
import { useMemo } from 'react'

export const useDrawer = (id: string) => {
  const { drawers, toggleDrawer, openDrawer, closeDrawer } = useDrawerStore()

  const isOpen = useMemo(() => drawers[id] || false, [drawers, id])

  return {
    isOpen,
    toggle: () => toggleDrawer(id),
    open: () => openDrawer(id),
    close: () => closeDrawer(id)
  }
}
